import React from "react";
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react";
import classNames from "classnames";
import styles from "./fix-details.module.scss";
import { Icon } from "@/elements-react/fix-icon";
import down from "@/assets/down-outlined.svg";

export interface FixDetailsProps {
  summary: string;
  children?: React.ReactNode;
  className?: string;
}

export const FixDetails: React.FC<FixDetailsProps> = ({ summary, children, className }) => {
  return (
    <Disclosure as="div" className={classNames(styles.fixDetails, className)}>
      {({ open }) => (
        <>
          <DisclosureButton
            className={classNames(styles.header, {
              [styles.opened]: open,
            })}
          >
            <span>{summary}</span>
            <Icon src={down} className={classNames(styles.summaryIcon)} />
          </DisclosureButton>

          <DisclosurePanel static className={styles.content} data-open={open ? "true" : "false"}>
            {children}
          </DisclosurePanel>
        </>
      )}
    </Disclosure>
  );
};
